'use client';

import TextLink from '@/atoms/Links/Text/TextLink';
import Image from 'next/image';

import {Styled404ImageContainer, Styled404TextContainer, StyledPageNotFound} from './styles';

const PageNotFoundNotification = (): JSX.Element => (
  <StyledPageNotFound>
    <Styled404TextContainer>
      <h1>Oops! Something went wrong.</h1>
      <p>
        Unfortunately we can&rsquo;t find the page you&rsquo;ve requested. This could be because its
        been moved, taken down or entered incorrectly.
      </p>
      <TextLink href="/">Go back to artfinder.com</TextLink>
    </Styled404TextContainer>
    <Styled404ImageContainer>
      <Image
        src={'https://d2m7ibezl7l5lt.cloudfront.net/img/404.4b3d854e96eb.svg'}
        alt="404 Image"
        width={500}
        height={460}
      />
    </Styled404ImageContainer>
  </StyledPageNotFound>
);

export default PageNotFoundNotification;
